import { Modal } from 'antd';

import { JobPostingActionModal } from './VacancyActions';

const DeleteVacancyModal: React.FC<JobPostingActionModal> = ({ jobPosting, ...props }) => {
  return (
    <Modal {...props}>
      <span>
        Ao excluir uma vaga todos os registros dela também serão excluídos e não poderão mais ser
        recuperados. Tem certeza que deseja excluir a vaga <strong>{jobPosting.name}</strong>?
      </span>
    </Modal>
  );
};

export default DeleteVacancyModal;
